import { THEME } from "@/3514/theme"

const FOREGROUND_COLOR: string = THEME.COLORS.gray[400]

const BACKGROUND_COLOR: string = THEME.COLORS.gray[500]

const config = { FOREGROUND_COLOR, BACKGROUND_COLOR }

export { config as contentLoaderConfig }
